<div class="login-wrapper">

  <!-- Left Panel — Branding -->
  <div class="login-left">
    <div class="brand">
      <img class="brand-logo-img" src="icon.png" alt="Jeeran Logo" />
      <p class="brand-tagline">Real Estate Dashboard</p>
    </div>
    <div class="brand-illustration">
      <div class="building building-1"></div>
      <div class="building building-2"></div>
      <div class="building building-3"></div>
      <div class="building building-4"></div>
      <div class="ground"></div>
    </div>
  </div>

  <!-- Right Panel — Login Form -->
  <div class="login-right">
    <div class="login-card">

      <div class="login-header">
        <img class="card-logo" src="icon.png" alt="Jeeran" />
        <h2>Welcome back</h2>
        <div class="accent-bar"></div>
        <p>Sign in to your dashboard</p>
      </div>

      <form class="login-form" (ngSubmit)="onSubmit()">

        <div class="form-group">
          <label for="email">Email address</label>
          <div class="input-wrapper">
            <span class="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
            </span>
            <input
              id="email"
              type="email"
              [(ngModel)]="credentials.email"
              name="email"
              placeholder="Enter your email"
              autocomplete="email"
            />
          </div>
        </div>

        <div class="form-group">
          <label for="password">
            Password
            <a href="#" class="forgot-link">Forgot password?</a>
          </label>
          <div class="input-wrapper">
            <span class="input-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
                <path d="M7 11V7a5 5 0 0 1 10 0v4" />
              </svg>
            </span>
            <input
              id="password"
              [type]="showPassword ? 'text' : 'password'"
              [(ngModel)]="credentials.password"
              name="password"
              placeholder="Enter your password"
              autocomplete="current-password"
            />
            <button type="button" class="toggle-password" (click)="togglePassword()">
              <svg *ngIf="!showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
                <circle cx="12" cy="12" r="3" />
              </svg>
              <svg *ngIf="showPassword" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"
                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
                <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
                <line x1="1" y1="1" x2="23" y2="23" />
              </svg>
            </button>
          </div>
        </div>

        <div class="error-message" *ngIf="errorMessage">
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/>
            <line x1="12" y1="16" x2="12.01" y2="16"/>
          </svg>
          {{ errorMessage }}
        </div>

        <button type="submit" class="btn-login" [disabled]="isLoading">
          <span *ngIf="!isLoading">Sign In</span>
          <span *ngIf="isLoading" class="spinner"></span>
        </button>

      </form>

    </div>
  </div>

</div>
